import { render } from "./PageLayout.vue?vue&type=template&id=5db0937a"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"

import "./PageLayout.vue?vue&type=style&index=0&id=5db0937a&lang=css"
script.render = render

export default script